import React, { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import UniversalButton from "@/components/common/UniversalButton";
import TermsText from "./BusinessDetailsForm/components/TermsText";
interface OwnerDetailsFormInputs {
  ownerName: string;
  ownerContactNumber: string;
  email: string;
}
interface OwnerDetailsFormProps {
  onSubmit: (data: OwnerDetailsFormInputs) => void;
  initialData?: Partial<OwnerDetailsFormInputs>;
  onChange?: (data: Partial<OwnerDetailsFormInputs>) => void;
  isLoading?: boolean;
}
const OwnerDetailsForm: React.FC<OwnerDetailsFormProps> = ({
  onSubmit,
  initialData = {},
  onChange,
  isLoading = false
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: {
      errors
    }
  } = useForm<OwnerDetailsFormInputs>({
    defaultValues: initialData
  });
  const watchedFields = watch();

  // Use useCallback to prevent function from changing on every render
  const stableOnChange = useCallback(onChange || (() => {}), [onChange]);
  useEffect(() => {
    if (stableOnChange && typeof stableOnChange === "function") {
      stableOnChange(watchedFields);
    }
  }, [watchedFields, stableOnChange]);
  return <form onSubmit={handleSubmit(onSubmit)}>
      <div className="space-y-4 lg:text-xl text-base ">
        <div>
          <label htmlFor="" className="font-lato font-normal mb-3 text-[#1E0C42]">
            Owner Name
          </label>
          <input type="text" {...register("ownerName", {
          required: "Owner Name is required"
        })} placeholder="Enter Owner name here" disabled={isLoading} className="w-full p-2 border-[0.65px] rounded-md border-[#D3D3D3] placeholder:font-lato placeholder:font-light focus:outline-none text-lg disabled:bg-gray-100 disabled:cursor-not-allowed" />
          {errors.ownerName && <p className="text-red-500 text-sm">
              {errors.ownerName.message as string}
            </p>}
        </div>
        <div>
          <label htmlFor="" className="font-lato font-normal mb-3 text-[#1E0C42] ">
            Owner Contact Number
          </label>
          <input type="tel" {...register("ownerContactNumber", {
          required: "owner contact number is required",
          pattern: {
            value: /^[6-9]\d{9}$/,
            message: "Invalid contact number"
          }
        })} inputMode="numeric" maxLength={10} minLength={10} placeholder="Enter Contact Number here" disabled={isLoading} className="w-full p-2 border-[0.65px] rounded-md border-[#D3D3D3] placeholder:font-lato placeholder:font-light placeholder:lg text-lg focus:bg-white disabled:bg-gray-100 disabled:cursor-not-allowed" />
          {errors.ownerContactNumber && <p className="text-red-500 text-sm">
              {errors.ownerContactNumber.message as string}
            </p>}
        </div>

        <div className="space-y-4">
          <div>
            <label htmlFor="" className="font-lato font-normal mb-3 text-[#1E0C42]">
              Owner Email Id
            </label>
            <input type="email" {...register("email", {
            required: "Email ID is required",
            pattern: {
              value: /^\S+@\S+$/i,
              message: "Invalid email address"
            }
          })} placeholder="Enter email address here" disabled={isLoading} className="w-full p-2 border rounded-md focus:outline-none text-lg focus:bg-white disabled:bg-gray-100 disabled:cursor-not-allowed" />
            {errors.email && <p className="text-red-500 text-sm">
                {errors.email.message as string}
              </p>}
          </div>
          <div className="flex flex-col items-center justify-center space-y-3 pt-14">
            <UniversalButton text={isLoading ? "Validating & Sending OTP..." : "Validate & Send OTP"} type="submit" variant="custom" classNames="lg:w-2/3 w-full bg-[#FD5C63] text-white py-2 rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed" disabled={isLoading} />
            <TermsText />
          </div>
        </div>
      </div>
    </form>;
};
export default OwnerDetailsForm;